import { PropsWithChildren, useState } from 'react'
import useIntersectionObserver from '@helpers/hooks/useIntersectionObserver'
import useIsStickyElement from '@helpers/hooks/useIsStickyElement'
import styles from '../styles.module.scss'

type StickyContainerProps = {
  isImageGalleryOpen: boolean
  hasEmptyOptions: boolean
  openOOSModal: boolean
}

export default function StickyContainer({
  isImageGalleryOpen,
  hasEmptyOptions,
  openOOSModal,
  children
}: PropsWithChildren<StickyContainerProps>) {
  const isSticky = useIsStickyElement({
    elementIdentifier: '.addToCartButton-container'
  })
  const [isIntersectingFooter, setIsIntersectingFooter] = useState(false)
  const [isAddToCartScrolledPastTop, setIsAddToCartScrolledPastTop] =
    useState(false)

  const onIntersectFooter: IntersectionObserverCallback = ([entry]) => {
    setIsIntersectingFooter(entry.isIntersecting)
  }

  const onIntersectAddToCart: IntersectionObserverCallback = ([entry]) => {
    setIsAddToCartScrolledPastTop(entry.boundingClientRect.top > 0)
  }

  useIntersectionObserver({
    elementIdentifier: '#footer',
    options: { threshold: 0.1 },
    onIntersect: onIntersectFooter
  })

  useIntersectionObserver({
    elementIdentifier: '#AddToCartButton',
    options: { threshold: 0.1 },
    onIntersect: onIntersectAddToCart
  })

  const shouldHideStickyContainer =
    isAddToCartScrolledPastTop ||
    isIntersectingFooter ||
    isImageGalleryOpen ||
    (!isSticky && !hasEmptyOptions) ||
    openOOSModal

  return (
    <div
      id="stickyAddToBagContainer"
      className={`${styles.stickyAddToBagContainer} ${
        shouldHideStickyContainer ? styles.isHidden : ''
      }`}
    >
      {children}
    </div>
  )
}
